<template>
  <v-card
    class="machinery-card-item is-clickable pa-3"
    flat
    @click="openEditMachineryDialog"
  >
    <v-row no-gutters align="center">
      <v-col class="col-12 col-sm-auto">
        <v-icon class="mr-4" color="primary" large>fas fa-hdd</v-icon>
      </v-col>
      <v-col class="flex-grow-1">
        <div class="body-2 font-weight-bold">{{ getMachineryNameCode }}</div>
        <div v-if="hasServices" :key="hasServices" class="service-list">
          <v-tooltip
            v-for="(service, i) in getLimitServiceList"
            :key="i"
            color="primary"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-chip
                class="service-chip text-uppercase my-1 ml-0 mr-1"
                color="primary"
                v-on="on"
                small
                ><span class="font-weight-bold text-truncate">
                  {{ service.nameByLang }}
                </span></v-chip
              >
            </template>
            <span class="font-weight-bold text-uppercase caption">{{
              service.nameByLang
            }}</span>
          </v-tooltip>
          <v-tooltip
            v-if="machinery.serviceList.length > 3"
            color="primary"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-chip
                class="service-chip font-weight-bold text-uppercase my-1 ml-0 px-1"
                color="primary"
                v-on="on"
                outlined
                small
                ><span class="text-truncate"
                  >+{{ getRemainingServiceList.length }}</span
                ></v-chip
              >
            </template>
            <span v-for="(service, j) in getRemainingServiceList" :key="j">
              <div class="font-weight-bold text-uppercase caption">
                {{ service.nameByLang }}
              </div>
            </span>
          </v-tooltip>
        </div>
        <span v-else :key="hasServices">
          <span>-</span>
          <i>
            {{ $t("hfManagement.machineryPerformance.noAvailableServiceMsg") }}
          </i>
        </span>
      </v-col>
      <v-col class="col-12 col-sm-auto">
        <v-btn
          color="primary"
          class="caption font-weight-bold"
          outlined
          rounded
          small
        >
          <span v-if="hasWritePerm">{{ $t("hfManagement.edit") }}</span>
          <span v-else>{{ $t("hfManagement.view") }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import chunk from "lodash/chunk";
import slice from "lodash/slice";

export default {
  props: {
    machinery: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      machineryServiceList: null
    };
  },
  created() {},
  computed: {
    hasWritePerm() {
      return this.$store.getters["auth/userHasRequiredAccess"](
        "GESTIONESTRUTTURASANITARIA",
        "READWRITE"
      );
    },
    getLimitServiceList() {
      return chunk(this.machinery.serviceList, 3)[0];
    },
    getRemainingServiceList() {
      let serviceList = this.machinery.serviceList;
      return slice(serviceList, 3, serviceList.length);
    },
    hasServices() {
      let totalServices = this.machinery.serviceList.length;
      return totalServices > 0;
    },
    getMachineryNameCode() {
      return `${this.machinery.name} ${this.machinery.code}`;
    }
  },
  methods: {
    openEditMachineryDialog() {
      this.$emit("openeditmachinerywithiddialog", this.machinery.machineryId);
    }
  }
};
</script>

<style scoped>
.service-list >>> .service-chip .v-chip__content {
  max-width: 180px;
}
</style>
